import store from "@frameworks/web/redux/store";
import { GUEST_REGISTER, GUEST_REGISTER_ERROR, GUEST_REGISTER_HIDE_ERROR, GUEST_REGISTER_START_LOADER, GUEST_REGISTER_STOP_LOADER, } from "../interface/iGuestRegister";
class GuestRegisterActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    guestRegister(data) {
        this.dispatch({
            type: GUEST_REGISTER,
            payload: { data },
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: GUEST_REGISTER_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: GUEST_REGISTER_HIDE_ERROR,
        });
    }
    loader() {
        this.dispatch({
            type: GUEST_REGISTER_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: GUEST_REGISTER_STOP_LOADER,
        });
    }
}
export default GuestRegisterActions;
